module.exports = __webpack_public_path__ + "static/media/Mush_Mozza-mb-fr.c8a4021e.jpg";